import React, { useEffect, useState } from "react";

import moment from "moment";

import { fileUpload, handleEditorChange, incomplete, prepareEditorContentImage } from "utils";

import { AdminSection, Button, Col, Form, Input, Radio, Row, TextArea, TextEditor, TimePicker, UploadImage } from "components";

export const ModuleDetailsForm = ({ isEditing, loading, module, onClose, onFinish }) => {
  const [form] = Form.useForm();
  const [isVideo, setIsVideo] = useState(true);
  const [content, setContent] = useState("");
  const [imageLoading, setImageLoading] = useState(false);
  const [imageSuccess, setImageSuccess] = useState(false);
  const [imageUrl, setImageUrl] = useState("");

  const handleSubmit = (v) => {
    const durationInSeconds = moment(v.duration).diff(moment(v.duration).startOf("day"), "seconds");

    const moduleDetails = {
      content,
      duration: durationInSeconds,
      image: !isVideo ? imageUrl : undefined,
      title: v.title,
      video: isVideo ? v.embedLink : undefined,
      takeaways: v.takeaways,
    };

    if (isVideo) {
      delete moduleDetails.image;
    } else {
      delete moduleDetails.video;
    }

    onFinish(moduleDetails, form);
  };

  useEffect(() => {
    if (!isEditing || !module) {
      return;
    }
    setContent(module.content);
    setIsVideo(Boolean(module.video));
    setImageUrl(module.image);
  }, [isEditing, module]);

  return (
    <Form style={{ margin: "0 auto" }} form={form} onFinish={handleSubmit} onFinishFailed={incomplete}>
      <Row className="margin-top-50">
        <Col>
          <Input name="title" label="Module title" rules={[{ required: true }]} initialValue={module ? module.title : ""} />
        </Col>
      </Row>
      <Row>
        <Col sm={24} md={12}>
          <TimePicker
            name="duration"
            label="Module duration (HH:MM:SS)"
            rules={[{ required: true }]}
            initialValue={module ? moment.utc(module.duration * 1000) : ""}
            showNow={false}
            format="HH:mm:ss"
          />
        </Col>
        <Col sm={24} md={12}>
          <Radio.Group
            defaultValue={module && module.image ? "image" : "video"}
            style={{
              display: "flex",
              gap: "1rem",
              height: "100%",
              justifyContent: "space-evenly",
              alignItems: "center",
            }}
          >
            <Radio onClick={() => setIsVideo(true)} value="video">
              Video
            </Radio>
            <Radio onClick={() => setIsVideo(false)} value="image">
              Image
            </Radio>
          </Radio.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          {isVideo ? (
            <Input name="embedLink" label="Vimeo video ID" rules={[{ required: true }]} initialValue={module ? module.video : ""} />
          ) : (
            <UploadImage
              imageSuccess={imageSuccess}
              imageUrl={imageUrl}
              label="Add image"
              uploading={imageLoading}
              beforeUpload={(v) => fileUpload(v, "courses", setImageSuccess, setImageUrl, setImageLoading)}
              value={imageUrl}
            />
          )}
        </Col>
      </Row>

      <AdminSection headline="Module content" />
      <Row>
        <Col>
          <TextEditor
            init={{
              images_upload_handler: (blobInfo, success) => {
                prepareEditorContentImage({ file: blobInfo.blob(), location: "courses" }).then((res) => success(res));
              },
            }}
            onEditorChange={(v) => handleEditorChange(v, setContent)}
            value={content}
          />
        </Col>
      </Row>

      <AdminSection headline="Key takeaways" />
      <Row>
        <Col>
          <TextArea
            name="takeaways"
            label="One per line"
            rules={[{ required: true }]}
            autoSize={{ minRows: 4 }}
            initialValue={module ? module.takeaways : ""}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Button type="primary" htmlType="submit" disabled={loading} loading={loading} className="margin-right-100">
            Save Module
          </Button>
          <Button disabled={loading} loading={loading} className="margin-right-100" onClick={onClose}>
            Cancel
          </Button>
        </Col>
      </Row>
    </Form>
  );
};
